module.exports = __webpack_public_path__ + "img/get.269d96bf.svg";